<template>
  <div>
    <v-card flat class="rounded-lg pa-6">
      <div class="d-flex align-start">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="#006341"
              v-bind="attrs"
              v-on="on"
              @click="$router.go(-1)"
              icon
              class="mr-3"
              ><v-icon>mdi-reply</v-icon></v-btn
            >
          </template>
          <span>Back</span>
        </v-tooltip>
        <div>
          <h1>Monitoring Internship</h1>
          <h3 v-if="dataSet && !loading" style="font-weight: normal">
            {{ dataSet.title }}
          </h3>
        </div>
      </div>
      <div class="mt-2">
        <v-card
          class="pa-2 rounded-lg"
          outlined
          v-if="dataSet && dataSet.description && !loading"
        >
          {{ dataSet.description ? dataSet.description : "No description yet" }}
        </v-card>
        <v-skeleton-loader
          class="mt-2"
          v-if="loading"
          type="image"
        ></v-skeleton-loader>
      </div>
    </v-card>
    <v-card flat class="rounded-lg pa-6 mt-6">
      <v-row>
        <v-col cols="6">
          <h4>Internship Place</h4>
          <v-card
            class="pa-2 rounded-lg mt-3"
            outlined
            v-if="dataSet && !loading"
          >
            {{ dataSet.destination }}
          </v-card>
          <v-skeleton-loader
            class="mt-2"
            v-if="loading"
            type="text"
          ></v-skeleton-loader>
        </v-col>
        <v-col cols="6"> </v-col>
        <v-col cols="6">
          <h4>Status Internship</h4>
          <v-card
            class="pa-2 rounded-lg mt-3"
            outlined
            v-if="dataSet && !loading"
          >
            {{ dataSet.proposal_status == "aktif" ? "Active" : "Done" }}
          </v-card>
          <v-skeleton-loader
            class="mt-2"
            v-if="loading"
            type="text"
          ></v-skeleton-loader>
        </v-col>
        <v-col cols="6"> </v-col>
        <v-col cols="6">
          <div style="height: 30px">
            <h4>Duration</h4>
          </div>
          <h6>Start</h6>
          <v-card
            class="pa-2 rounded-lg mt-1"
            outlined
            v-if="dataSet && !loading"
          >
            {{ $date(dataSet.durasi_start).format("dddd, DD MMMM YYYY") }}
          </v-card>
          <v-skeleton-loader
            class="mt-2"
            v-if="loading"
            type="text"
          ></v-skeleton-loader>
        </v-col>
        <v-col cols="6">
          <div style="height: 30px"></div>
          <h6>End</h6>
          <v-card
            class="pa-2 rounded-lg mt-1"
            outlined
            v-if="dataSet && !loading"
          >
            {{ $date(dataSet.durasi_end).format("dddd, DD MMMM YYYY") }}
          </v-card>
          <v-skeleton-loader
            class="mt-2"
            v-if="loading"
            type="text"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "monitoringInternshipScholar",
  data() {
    return {
      showPickerStart: false,
      showPickerEnd: false,
      optStatusInternship: [
        {
          name: "Active",
          val: "aktif",
        },
        {
          name: "Done",
          val: "selesai",
        },
      ],
      loading: true,
      dataSet: null,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    closeDateMenu(type) {
      if (type == "start") {
        this.showPickerStart = false;
        this.dataSet.durasi_start == ""
          ? this.date.format("dddd, MMMM Do YYYY")
          : "";
      } else {
        this.showPickerEnd = false;
        this.dataSet.durasi_end == ""
          ? this.date.format("dddd, MMMM Do YYYY")
          : "";
      }
    },
    fetchData() {
      this.loading = true;
      let data = {
        path: `proposal/internships?filter[scholar_intern_proposal.id]=${this.$route.params.idProposal}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.dataSet = data.data.length ? data.data[0] : null;
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
  },
};
</script>

<style></style>
